import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import down from "../assets/down.png"
import img from "../assets/img.png"
import Dashboardfooter from '../profile/Dashboardfooter'
import cross from "../assets/cross.png"
import Selectcustom from '../Info/Selectcustom'
import Selectcustoms from '../Info/Selectcustoms'

function Posting() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
            <Navbars />
            {/* <h1>posting</h1> */}
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='main_grid pt-3'>
                    <div className='inner_div  ps-3 pe-3 mb-5 pb-5'>
                        <div className='d-flex justify-content-between gap-3 pt-4 flex-wrap ' >
                            <p className='adx_no'>Cube ADX - #00019298812</p>
                            <div className='d-flex gap-1'>
                                <p className='balance'>Your Balance:</p>
                                <p>$1000.00</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label'>1- Business Name</p>
                                <input className='input1' placeholder='Cube Adx' />
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <div className='w-100'>
                                    <p className='label'>2- Business Category</p>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <Selectcustom placeholder={"Message Services"} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className='label'>3- Address</p>
                        <div className='row'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label1'>Street Number / Name</p>
                                <input className='input1 w-100' placeholder='106 Douers' />
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 '>
                                <p className='label1'>State</p>
                                <div style={{ position: "relative", maxWidth: "600px" }}>
                                    <Selectcustoms placeholder={'State'} />

                                </div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6'>
                                <p className='label1'>City</p>
                                <div style={{ position: "relative", maxWidth: "600px" }}>
                                    <Selectcustoms placeholder={'City'} /></div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6'>
                                <p className='label1'>City Zip</p>
                                <div style={{ position: "relative", maxWidth: "600px" }}>
                                    <Selectcustoms placeholder={'Zip Code'} />
                                </div>
                            </div>

                        </div>
                        <div className='row mt-3'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label1'>4- Phone Number</p>
                                <input className='input1 w-100' placeholder='+1490300330' />
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 '>
                                <p className='label2'>6-Upload up to 5 images <span> (size must be
                                    (950px X 720px) and (1900px X
                                    1440px) Each)</span> </p>
                                <button className='upload_btn'>Upload Files</button>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6 mt-1'>
                                <p className='label2'>Upload a Video </p>
                                <button className='upload_btn' style={{ marginTop: "33px" }}>Upload Files</button>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6 mt-1'>
                                <p className='label2'>Upload Logo image <br></br>
                                    <span>(400px X 400 px)  </span> </p>
                                <button className='upload_btn' style={{ marginTop: "10px" }}>Upload Files</button>
                            </div>

                        </div>
                        <div className='row mt-3'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label1'>5- Business Email</p>
                                <input className='input1 w-100' placeholder='info@cubeadx.com' />
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 mt-1 '>
                                <div className='d-flex gap-1 flex-wrap'>
                                    <img src={img} />
                                    <img src={img} />
                                    <img src={img} />
                                    <img src={img} />
                                    {/* <img src={img}/> */}
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6 mt-1'>
                                <img src={img} />
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-6 mt-1'>
                                <img src={img} />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label1'>7- Add up to 10 key words<span className='span_txt'> ( Max 30 letters/keyword) </span></p>
                                <div className='input1 ps-2 pe-2 pb-2'>
                                    <div className='d-flex gap-1 flex-wrap'>
                                        <div className='badge_main'>
                                            <p>Los Angeles</p>
                                            <div className='badge_inner'>
                                                <img src={cross} />
                                            </div>
                                        </div>
                                        <div className='badge_main'>
                                            <p>Business</p>
                                            <div className='badge_inner'>
                                                <img src={cross} />
                                            </div>
                                        </div>
                                        <div className='badge_main'>
                                            <p>Mesa</p>
                                            <div className='badge_inner'>
                                                <img src={cross} />
                                            </div>
                                        </div>
                                        <div className='badge_main'>
                                            <p>Mesa</p>
                                            <div className='badge_inner'>
                                                <img src={cross} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 '>
                                <div className='d-flex gap-1 flex-wrap'>
                                    <p className='label1'>8- Add extra City <span className='span_txt'> (you can choose different Cities) </span></p>
                                    <div className='d-flex gap-1'>
                                        <div style={{ position: "relative", maxWidth: "600px" }}>
                                            <input className='input1 w-100' placeholder='City - 1' />
                                            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                                <img src={down} />
                                            </div>
                                        </div>
                                        <div style={{ position: "relative", maxWidth: "600px" }}>
                                            <input className='input1 w-100' placeholder='City - 2' />
                                            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                                <img src={down} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className='input1 ps-2 pe-2 pb-2 mt-2'>
                                        <div className='d-flex gap-1 flex-wrap'>
                                            <div className='badge_main'>
                                                <p>Los Angeles</p>
                                                <div className='badge_inner'>
                                                    <img src={cross} />
                                                </div>
                                            </div>
                                            <div className='badge_main'>
                                                <p>Business</p>
                                                <div className='badge_inner'>
                                                    <img src={cross} />
                                                </div>
                                            </div>
                                            <div className='badge_main'>
                                                <p>Mesa</p>
                                                <div className='badge_inner'>
                                                    <img src={cross} />
                                                </div>
                                            </div>
                                            <div className='badge_main'>
                                                <p>Mesa</p>
                                                <div className='badge_inner'>
                                                    <img src={cross} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='label1'>Business Website</p>
                                <input className='input1' placeholder='www.cubeadx.com' />
                            </div>
                        </div>
                        <Dashboardfooter />
                    </div>
                </div>
            </div>
        </div>



    </>

    )
}

export default Posting